<script>
import ProductService from '../services/api/ProductService';

export default {
    data() {
        return {
            page: +this.$route.query.page || 1,
            total: 0,
            lastPage: 1,
            pagination: 30,
            products: [],
            listLoading: false,
        }
    },
    computed: {
        loadMore() {
            return this.page !== this.lastPage;
        },
    },
    methods: {
        incrementPage() {
            this.page++;
        },
        setPage(page) {
            this.page = page;
            this.products = [];
        },
        setProducts() {
            if (this.listLoading) {
                return false;
            }

            this.beforeProductsRequest();

            this.listLoading = true;

            ProductService.setLocale(this.$store.state.language.appLanguage);
            ProductService.getList(this.filters || {}, this.page, this.pagination, this.sortData, this.attribute)
                .then(res => {
                    const {total, last_page, data} = res.data;
                    this.total = parseInt(total);
                    this.lastPage = parseInt(last_page);
                    this.products.push(...data);
                    this.listLoading = false;
                })
                .catch(() => {})
        },
        updateProducts() {
            this.products = [];
            this.setProducts();
        },
        beforeProductsRequest() {
            /* override if you need to do something before the request */
        },
    },
    watch: {
        page() {
            this.setProducts();
        },
        lastPage(val) {
            if (this.page > val) {
                this.page = val;
            }
        }
    }
}
</script>
